module.exports = vendor_b04a10c0b96e63ef5adb;